import { formLabelClasses } from "@mui/material";
const MuiFormLabel = {
    styleOverrides: {
        root: {
            [`&.${formLabelClasses.focused}`]: {
                color: 'inherit'
            }
        }
    }
};
export { MuiFormLabel };

//# sourceMappingURL=form-label.js.map